module.exports = require("ieee754");